import React, {Component} from 'react';
import Select from 'react-select';
import classNames from 'classnames';
import t from 'tcomb-form';

export default class FormSelect extends Component {
    static displayName = 'FormSelect';

    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    }

    handleChange = (option) => {
        this.setState({
            value: option.value
        });
        this.props.onChange(option.value, this.props.ctx.path);
    };

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.state.value;
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const label = this.props.options.label || this.props.ctx.label;
        const options = this.props.options.options || this.props.type.meta.map;
        const {value, hasError} = this.state;
        const currentValue = options[value] || options[0];
        const currentValueNode = {value: value, label: currentValue};

        const optionNodes = Object.keys(options).map(k => {
            return {value: k, label: options[k]}
        }).sort((a, b) => {
            const labelA = a.label.toUpperCase();
            const labelB = b.label.toUpperCase();
            if (labelA < labelB) {
                return -1;
            }
            if (labelA > labelB) {
                return 1;
            }
            return 0;
        });

        return (
            <div className={classNames('form-group', hasError && 'has-error', 'form-dropdown')}>
                <label className="control-label">{label}</label>
                <Select
                    className="dropdown"
                    searchable={true}
                    clearable={false}
                    value={currentValueNode}
                    options={optionNodes}
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_select.js